export class Contact {
  id: number;
  first_name: string;
  gender: string;
  last_name: string;
  selected: boolean = false;
  type: string;
  display_name: string;
  company_name: string;
  company_suffix: string;
  ein: string;
  qualifier_id: number;
  middle_name: string;
  generational_qualifier_id: number;
  honorarium_id: number;
  dob: any;
  dob_struct: any;
  dod: any;
  dod_struct: any;
  ssn: string;
  employer_id: number | null;
  owned_by: number;
  url: string;
  share_password: string;
  referral_source: boolean = false;
  referral_destination: boolean = false;
  is_on_mailing_list: boolean = false;
  is_private: boolean = false;
  requires_1099: boolean = false;
  notes: string;
  matter_ids_size: number;
  matters_url: string;
  primary_phone: string;
  primary_email: string;
  name: string;
}
